import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';

import SubjectItemsList from 'modules/documents/components/SubjectItemList/SubjectItemsList';

import { useVideos } from '../../hooks';

const MediaPage = () => {
  const { courseId, subjectId } = useParams<{ courseId: string; subjectId: string }>();
  const { loading, videos } = useVideos({ courseId, subjectId });
  const history = useHistory();
  const intl = useIntl();

  const onOpenVideo = useCallback(
    (video: any) => {
      if (video.isExternal) {
        // eslint-disable-next-line no-undef
        window.open(video.externalUrl, video.name);
      } else {
        history.push(`media-player/${video._id}`);
      }
    },
    [history]
  );

  const getName = (video: any) => video?.name;

  const getBackgroundImage = (video: any) => video?.thumbUrl;

  return (
    <SubjectItemsList
      getName={getName}
      getBackgroundImage={getBackgroundImage}
      items={videos}
      loading={loading}
      onSelectItem={onOpenVideo}
      noItemsMessage={intl.formatMessage({ id: 'noVideosInSubject' })}
    />
  );
};

export default MediaPage;
